import {
  OneOfElements,
  OneOfPropertyElements,
} from '@shared/models/project.model';
import { isOneOfPropertyElements } from '../../recursive-element.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';
import { addElementProperties } from '../../element-property-factory.helpers';
import {
  contentCoverageFactoryOverridesFrom,
  isContentCoverageFactoryShape,
  toContentCoverageFactory,
} from '../../../templates/categories/common-element-category-properties.helpers';

type PropertyAddChange = ProjectChangeMap[ProjectChangeType.ElementPropertyAdd];

/**
 * Add a property to an element using the factory definition from the change.
 * Delegates to {@link addElementProperties} to create the property with correct defaults.
 *
 * @param element - Current element state
 * @param change - Payload with the {@link IFactoryProperty} to create
 * @returns Partial with updated properties array, or undefined when element has no properties
 */
export const elementPropertyAddToChange = (
  element: OneOfElements,
  change: PropertyAddChange,
): Partial<OneOfPropertyElements> | undefined => {
  if (!isOneOfPropertyElements(element)) return undefined;

  const factory = isContentCoverageFactoryShape(change.factory)
    ? toContentCoverageFactory(
        contentCoverageFactoryOverridesFrom(change.factory),
      )
    : change.factory;
  const updated = addElementProperties(element, factory);
  return { properties: updated.properties };
};
